import React from 'react';
import IconMapEnlarge from '@spothero/icons/map-enlarge';
import { Button } from '@spothero/ui-backlog';
import SpotDetailsDirectionsMap from '../directions-map';
import SpotDetailsDirectionsMapModal from '../directions-map-modal';
const SpotDetailsPanelMap = (props) => {
    const [showModal, setShowModal] = React.useState(false);
    const { spotLatitude, spotLongitude, destinationLatitude, destinationLongitude, isDriving, linearMeters, walkingMeters, walkingDuration, } = props;
    const walkingProps = {
        linearMeters,
        walkingMeters,
        walkingDuration,
    };
    return (<div className="SpotDetailsPanelMap">
            <SpotDetailsDirectionsMap isDraggable={false} spotLatitude={spotLatitude} spotLongitude={spotLongitude} destinationLatitude={destinationLatitude} destinationLongitude={destinationLongitude} isDriving={isDriving} disableDefaultUI onClick={() => setShowModal(true)} {...(!isDriving && walkingProps)}/>
            <Button className="SpotDetailsPanelMap-enlarge" onClick={() => setShowModal(true)}>
                <IconMapEnlarge />
            </Button>
            {showModal && (<SpotDetailsDirectionsMapModal spotLatitude={spotLatitude} spotLongitude={spotLongitude} destinationLatitude={destinationLatitude} destinationLongitude={destinationLongitude} isDriving={isDriving} onHidden={() => setShowModal(false)} {...(!isDriving && walkingProps)}/>)}
        </div>);
};
export default SpotDetailsPanelMap;
